import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE} from 'util/constants';

module.exports = {
    createFetchParams: type => ({
        type
    }),
    ...storeModuleFactory({
        name:               'customerProductsDetails',
        endpoint:           endpoints.customerProducts.produtsDetails,
        timeout:            TIMEOUT_STORE.TIMEOUT_STORE_BIG,
        transformResultsFn: response => ({
            results: !response.results ? [] : response.results.map(item => ({
                productType:            item.product_type,
                descProduct:            item.desc_product,
                assetNumber:            item.asset_number,
                productID:              item.product_id,
                quantity:               item.quantity,
                uom:                    item.uom,
                tier:                   item.tier,
                backupProtection:       item.backup_protection,
                typeOfMonitoring:       item.type_of_monitoring,
                comercialModen:         item.comercial_mode,
                backupRetentionOffsite: item.backup_retention_offsite,
                descElement:            item.desc_element,
                volume:                 item.volume,
                iops:                   item.iops,
                type:                   item.type
            }))
        })
    })
};



// WEBPACK FOOTER //
// ./src/modules/store/customerProductsDetails.js